// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const IconContainer = styled.div`
  padding-right: var(--mantine-spacing-xs);
`;
